export default "__VITE_ASSET__57850bd6__"